"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const lodash_es_1 = require("lodash-es");
const constants_1 = require("../../tests/constants");
const useClickableProps_1 = __importDefault(require("../../hooks/useClickableProps/useClickableProps"));
const bem_helper_1 = require("../../helpers/bem-helper");
require("./Clickable.scss");
const CSS_BASE_CLASS = "monday-style-clickable";
const bemHelper = (0, bem_helper_1.BEMClass)(CSS_BASE_CLASS);
const Clickable = (0, react_1.forwardRef)(({ elementType = "div", className = "", id, children, role = "button", onClick = lodash_es_1.noop, enableTextSelection = false, onMouseDown = lodash_es_1.noop, onMouseEnter = lodash_es_1.noop, onMouseLeave = lodash_es_1.noop, ariaLabel, ariaHidden, ariaHasPopup, ariaExpanded, tabIndex = "0", disabled = false, style, dataTestId }, ref) => {
    const clickableProps = (0, useClickableProps_1.default)({
        onClick,
        onMouseDown,
        onMouseEnter,
        onMouseLeave,
        disabled,
        id,
        dataTestId,
        role,
        tabIndex,
        ariaLabel,
        ariaHidden,
        ariaHasPopup,
        ariaExpanded
    }, ref);
    const overrideClassName = (0, classnames_1.default)(CSS_BASE_CLASS, className, {
        disabled,
        [bemHelper({ state: "disable-text-selection" })]: !enableTextSelection
    });
    return react_1.default.createElement(elementType, Object.assign(Object.assign({}, clickableProps), { className: overrideClassName, style: style }), children);
});
Object.assign(Clickable, {
    defaultTestId: constants_1.ComponentDefaultTestId.CLICKABLE
});
exports.default = Clickable;
